import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { PhoenixDirectivesModule } from '../../../directives/directives.module';
import { LinkedSubjectsWidgetComponent } from './linked-subjects-widget.component';
import { ProcessListWidgetComponent } from './process-list-widget/process-list-widget.component';
import { RecentHistoryWidgetComponent } from './recent-history-widget.component';
import { SubjectListWidgetComponent } from './subject-list-widget/subject-list-widget.component';
import { FileListWidgetComponent } from './file-list-widget/file-list-widget.component';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { FilesModule } from '../../content/files/files.module';
import { MarkerListWidgetComponent } from './marker-list-widget/marker-list-widget.component';
import { SubjectComponentsModule } from 'app/main/content/subjects/subject-components.module';
import { ReviewListWidgetComponent } from './review-list-widget/review-list-widget.component';
import { AssessmentListWidgetComponent } from './assessment-list-widget/assessment-list-widget.component';
import { DevExtremeModule } from 'devextreme-angular';
import { SelectMarkerComponent } from './marker-list-widget/select-marker/select-marker.component';
import { DataGridModule } from 'app/components/data-grid/data-grid.module';
import { AuditListWidgetComponent } from './audit-list-widget/audit-list-widget.component';
import { AuditComponentsModule } from 'app/main/content/audits/audit-components.module';
import { ChecklistWidgetComponent } from './checklist-list-widget/checklist-list-widget.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatRippleModule,
        FuseWidgetModule,
        MatButtonModule,
        MatDialogModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDividerModule,
        MatMenuModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        FuseWidgetModule,
        FuseSharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule,
        FilesModule,
        SubjectComponentsModule,
        DevExtremeModule,
        DataGridModule,
        AuditComponentsModule,
        
    ],
    declarations: [
        SubjectListWidgetComponent,
        RecentHistoryWidgetComponent,
        LinkedSubjectsWidgetComponent,
        ProcessListWidgetComponent,
        ChecklistWidgetComponent,
        FileListWidgetComponent,
        MarkerListWidgetComponent,
        SelectMarkerComponent,
        ReviewListWidgetComponent,
        AssessmentListWidgetComponent,
        AuditListWidgetComponent,
    ],
    exports: [
        SubjectListWidgetComponent,
        RecentHistoryWidgetComponent,
        LinkedSubjectsWidgetComponent,
        ProcessListWidgetComponent,
        ChecklistWidgetComponent,
        FileListWidgetComponent,
        MarkerListWidgetComponent,
        ReviewListWidgetComponent,
        AssessmentListWidgetComponent,
        AuditListWidgetComponent,
    ]
})
export class ListWidgetsModule { }
